<script setup lang="ts">
const { initSmarticoError, isReadyGamefication } =
  storeToRefs(useSmarticoInit());

const { isGamificationLevelsActived } = storeToRefs(useSmarticoConfigs());

const { loadUserInfosProfile } = useSmarticoUserInfos();

const { isDesktop } = useLayout();

const loadComponent = computed(
  () =>
    isGamificationLevelsActived.value &&
    !initSmarticoError.value &&
    isReadyGamefication.value,
);

// Mobile e desktop são duas estruturas diferentes (abas x página única de
// scroll com pódio e comparativo), então cada uma é uma árvore própria e só a
// que vale monta — esconder por CSS pagaria as duas.
//
// A celebração de subida de elo NÃO vive aqui: é global, montada no `app.vue`
// por LevelsLevelUpWatcher, porque o jogador sobe de elo apostando e não parado
// nesta tela.
onMounted(() => {
  loadUserInfosProfile();
});
</script>

<template>
  <!--
    As margens negativas cancelam o padding do `.content` do layout default
    (`pt-4 lg:pt-6 xl:pt-8` + `px-4 md:px-0 lg:px-4`): esta página pinta o
    próprio fundo — gradiente radial com o glow do elo ancorado em `50% 0%` —
    e dentro do padding o glow sai cortado, o fundo começa recuado e sobra o
    dobro de espaço morto entre o header e o cartão do jogador. Sem `w-full`
    de propósito: com largura fixa a margem negativa da direita é ignorada e a
    caixa desalinha; largura automática expande pelos dois lados. Se o padding
    do layout mudar, estes valores mudam junto.
  -->
  <!--
    `select-none` e `dragstart` barrado valem para a árvore toda: a página é
    vitrine, não texto para copiar, e arrastar pedaço de arte para fora só
    quebra a composição. As artes de elo são todas `background-image`, que o
    browser já não deixa arrastar — o handler cobre o subárvore do loader e
    qualquer `<img>` que apareça aqui depois.
  -->
  <div
    class="relative -mx-4 -mt-4 flex min-h-[600px] select-none justify-center md:mx-0 lg:-mx-4 lg:-mt-6 xl:-mt-8"
    @dragstart.prevent
  >
    <SmarticoAlertsAndLoader
      v-if="!loadComponent"
      :force-show-error="!isGamificationLevelsActived"
    />

    <LevelsDesktopView v-else-if="isDesktop" />

    <LevelsMobileView v-else />
  </div>

  <!-- h1 de SEO no rodapé, mesmo padrão das outras páginas VIP (loja,
       mini-games): a página não tem outro h1 — as seções internas usam h2. -->
  <h1 class="mb-8 px-4 text-center leading-tight text-white/60">
    Programa de fidelidade ApostaTudo: como funcionam os níveis.
  </h1>
</template>
